<template>
  <path
    d="M4 18.0002H20C20.55 18.0002 21 17.5502 21 17.0002C21 16.4502 20.55 16.0002 20 16.0002H4C3.45 16.0002 3 16.4502 3 17.0002C3 17.5502 3.45 18.0002 4 18.0002ZM4 13.0002H20C20.55 13.0002 21 12.5502 21 12.0002C21 11.4502 20.55 11.0002 20 11.0002H4C3.45 11.0002 3 11.4502 3 12.0002C3 12.5502 3.45 13.0002 4 13.0002ZM3 7.00024C3 7.55024 3.45 8.00024 4 8.00024H20C20.55 8.00024 21 7.55024 21 7.00024C21 6.45024 20.55 6.00024 20 6.00024H4C3.45 6.00024 3 6.45024 3 7.00024Z"
  />
</template>
